<template>
  <v-text-field
    v-model="likePattern"
    clearable
    @keyup.enter="applyFiltersAndGetItems"
    label="Patrón LIKE para el nombre"
    prepend-icon="check"
  />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "classifier"
);

export default {
  computed: {
    ...mapState(["likePatternNameFilter"]),
    likePattern: {
      set(pattern) {
        this.setLikePatternNameFilter(pattern);
      },
      get() {
        return this.likePatternNameFilter;
      }
    }
  },
  methods: {
    ...mapMutations(["setLikePatternNameFilter"]),
    ...mapActions(["applyFiltersAndGetItems"])
  }
};
</script>